import React, { useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import business from "../assets/business.png";
import cross from "../assets/cross.png";
import feed from "../assets/feed.png";
import video from "../assets/video.png";
import imagegallery from "../assets/imagegallery.png";
import videogallery from "../assets/videogallery.png";
import { useDropzone } from "react-dropzone";
import inforound from "../assets/inforound.png";
import tick from "../assets/tick.png";
import "./Steppers.css";
import { Player } from 'video-react';
import { toast } from "react-toastify";
import "../../../node_modules/video-react/dist/video-react.css";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { useAddbusinessMutation } from "../../services/api";
import UploadFile from "../upload/UploadFile";
import UploadVideo from "../upload/UploadVideo";
function Preview() {
  const [preview, setPreview] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let imagesList = [];
  const [imageUrl, setImageUrl] = useState([]);
  const [previewImg, setPreviewImg] = useState([]);
  const [logoUrl, setLogoUrl] = useState("");
  const [previewLogo, setPreviewLogo] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [previewVideo, setPreviewVideo] = useState("");
  const [addbusiness, { isLoading, isError }] = useAddbusinessMutation();
  const firstPageData = useSelector((state) => state.addBusiness.firstPage);
  const secondPageData = useSelector((state) => state.addBusiness.secondPage);
  const thirdPageData = useSelector((state) => state.addBusiness.thirdPage);
  const fourthPageData = useSelector((state) => state.addBusiness.fourthPage);
  const [previewData, setPreviewData] = useState({});
  useEffect(() => {
    if (location.pathname == "/preview") setPreview(true);
  }, []);

  useEffect(() => {
    console.log("All data: ", {
      ...firstPageData,
      ...secondPageData,
      ...thirdPageData,
      ...fourthPageData,
    });

    setPreviewData({
      ...firstPageData,
      ...secondPageData,
      ...thirdPageData,
      ...fourthPageData,
    });
  }, [firstPageData, secondPageData, thirdPageData, fourthPageData]);

  const handleProceed = () => {
    let formData = new FormData();
    if(imageUrl.length>0)
    imageUrl.forEach((file, index) => {
      formData.append(`images`, file); // Append each file to the form data with the same key
    });
 
    formData.append("logo", logoUrl);
    formData.append("video", videoUrl);
    formData.append("business_name", previewData.businessName);
    formData.append("phone_number", previewData.phone_number);
    formData.append("email", previewData.businessEmail);
    formData.append("street_name", previewData.streetNo);
    formData.append("city_zip", previewData.cityZip);
    formData.append("city1", previewData.cityOne);
    formData.append("city2", previewData.cityTwo);
    formData.append("state", previewData.state);
    formData.append("website", previewData.businessWebsite);
    formData.append("business_description", previewData.businessDescription);
    formData.append("business_days_and_hours", previewData.dateAndTime);
    formData.append("keyword", [1]);
    formData.append("category", previewData.category);
    addbusiness(formData)
      .unwrap()
      .then((payload) => {
        console.log("payload", payload);
        toast.success("Business Added Successfully");
        // setAllKeywords(payload);
        // dispatch(setKeywords(payload));
      })
      .catch((error) => {
        console.log(error);
        toast.success("Somthing wen wrong");
      });
    // dispatch(
    //   addBusiness({
    //     images: previewData.image,
    //     business_name: previewData.businessName,
    //     phone_number: previewData.businessPhoneNo,
    //     email: previewData.businessEmail,
    //     street_name: previewData.streetNo,
    //     city_zip: previewData.cityZip,
    //     city1: previewData.cityOne,
    //     city2: previewData.cityTwo,
    //     state: previewData.state,
    //     business_description: previewData.businessDescription,
    //     business_days_and_hours: previewData.dateAndTime,
    //     category: parseInt(previewData.businessCategory),
    //     keywords: previewData.tags,
    //   })
    // );
  };

  const proceed = () => {
    handleProceed();
    navigate("/listing");
  };
  const nextpage = () => {
    setPreview(true);
  };
  const onDrop = useCallback((acceptedFiles) => {
    console.log("acceptedFiles: ", acceptedFiles[0]);
    imagesList = [...imagesList, acceptedFiles[0]];
    console.log("Accepted File: ", imagesList);

    // console.log("Image URL: ", URL.createObjectURL(acceptedFiles[0]));
    setPreviewImg(URL.createObjectURL(acceptedFiles[0]));
    setImageUrl(acceptedFiles[0]);

    // dispatch(setFourthPage({images:acceptedFiles[0]}));
  }, []);

  const onImageUpload = (file) => {
    setPreviewImg([]);
    setImageUrl(file);
    if(file.length<6)
    file.forEach((file) => {
      const reader = new FileReader();

      reader.onload = () => {
        if (reader.readyState === 2) {
          setPreviewImg((oldArray) => [...oldArray, reader.result]);
          // setImages(...[e.target.files]);
        }
      };

      reader.readAsDataURL(file);
    });
    else toast.success("Images should be less than 6");
  };
  const onLogoUpload = (file) => {
    setPreviewLogo(URL.createObjectURL(file[0]));
    setLogoUrl(file[0]);

  };
  const onVideoUpload = (file) => {
    setPreviewVideo(URL.createObjectURL(file));
    setVideoUrl(file);

  };
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <>
      {preview == false ? (
        <div
          className="d-flex align-items-center ps-3 pe-3 box_height mb-5"
          style={{ height: "100vh", width: "100%" }}
        >
          <div className="container box_div">
            <div className="steper_div">
              <div className="num">
                <img className="tick_img" src={tick} />
              </div>
              <div className="border_bottom_div"></div>
              <div className="num">
                <img className="tick_img" src={tick} />
              </div>
              <div className="border_bottom_div"></div>
              <div className="num">
                <img className="tick_img" src={tick} />
              </div>
              <div className="border_bottom_div"></div>
              <div className="num">
                <p>4</p>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <div className="video_card">
                <p className="business_heading1_main">Add Business Detail</p>
                <p className="video_text">
                  Upload up to 5 images
                  <span className="video_span">(Min 1 image),</span> a video
                  <span className="video_span">(Optional) and a</span> Logo{" "}
                  <span className="video_span">
                    (Optional - 400px X 400px) (950px X 720px) Or (1900px X
                    1440px)
                  </span>
                </p>
                <div className="d-flex gap-2 flex-wrap justify-content-center mt-4 mb-3">
               
                  {/* <img className="gallery_img" src={imagegallery} /> */}
                 
                  
                  
                  
                  {previewImg.length > 0?previewImg.map((url)=><img
                      className="gallery_img"
                      src={url}
                    />):
                    <UploadFile onImageUpload={onImageUpload} logo={false}/>
                  }
                  {previewVideo.length > 0?<div className="gallery_img d-flex flex-column justify-content-center align-items-center">
                  <h6>Video uploaded</h6>
                  <h6>{videoUrl.name}</h6>
                    
                  </div>:
                    <UploadVideo onVideoUpload={onVideoUpload}/>
                  }
                 
                  {previewLogo.length > 0?<img
                      className="gallery_img"
                      src={previewLogo}
                    />:
                    <UploadFile onLogoUpload={onLogoUpload} logo={true}/>
                  }
                  
                  
                </div>
                <div className="d-flex gap-2 align-items-center justify-content-center inforound_div">
                  <img src={inforound} />
                  <p className="heading_inforound">
                    Do not upload any illegal and/or copy written content!
                  </p>
                </div>

                <div className="d-flex justify-content-center">
                  <button className="done_btn" onClick={nextpage}>
                    DONE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="container">
          <div className="d-flex gap-2 align-items-center pt-5 ps-3 pe-3 preview_maindiv">
            <div className="back_div">
              <p className="back_text">Back</p>
            </div>
            <p className="preview_heading">Business Detail’s Preview</p>
          </div>
          <div className="box_div mt-5 mb-5 box_setting">
            <div className="d-flex justify-content-center">
              <div>
                <img className="business_pic" src={business} />
                <p className="business_description">Cube Adx</p>
              </div>
            </div>
            <p className="label1 labels">1- Business Information</p>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <p className="label1">Business Name</p>
                <input
                  value={previewData?.businessName}
                  className="input1"
                  placeholder="Cube Adx"
                />
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <p className="label1">Phone Number</p>
                <input
                  value={previewData?.businessPhoneNo}
                  className="input1"
                  placeholder="+1490300330"
                />
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <p className="label1">
                  Business Email{" "}
                  <span className="labels_span"> (Optional) </span>
                </p>
                <input
                  value={previewData?.businessEmai}
                  className="input1"
                  placeholder="info@cubeadx.com"
                />
              </div>
            </div>
            <p className="label1 labels">2- Business Address</p>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <p className="label1">Street# / Name</p>
                <input
                  value={previewData?.streetNo}
                  className="input1"
                  placeholder="Street# / Name"
                />
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <p className="label1">City Zip</p>
                <input
                  value={previewData?.cityZip}
                  className="input1"
                  placeholder="Zip"
                />
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <p className="label1">State</p>
                <input
                  value={previewData?.state}
                  className="input1"
                  placeholder="State"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <p className="label1 labels">3- Business Category</p>
                <input
                  value={previewData?.businessCategory}
                  className="input1"
                  placeholder="Message Services"
                />
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <p className="label1 labels">Business Website</p>
                <input
                  value={previewData?.businessWebsite}
                  className="input1"
                  placeholder="www.cubeadx.com"
                />
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12"></div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12">
                {previewData.dateAndTime &&
                  previewData.dateAndTime.map((elem) => {
                    return (
                      <div className="row">
                        <p className="label1 labels">Business Working Days</p>
                        <div className=" col-lg-6 col-md-6 col-sm-12 ">
                          <div className="time_div">
                            <p className="days">{elem?.day.toUpperCase()}</p>
                          </div>
                        </div>
                        <div className=" col-lg-6 col-md-6 col-sm-12 ">
                          <div className="time_div">
                            <p className="days">
                              {elem.open_time} - {elem.close_time}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                {/* <div className="row">
                <p className="label1 labels">Business Working Days</p>
                <div className=" col-lg-6 col-md-6 col-sm-12 ">
                  <div className="time_div">
                    <p className="days">Mon</p>
                  </div>
                </div>
                <div className=" col-lg-6 col-md-6 col-sm-12 ">
                  <div className="time_div">
                    <p className="days">10:00AM - 06:00PM</p>
                  </div>
                </div>
              </div> */}
                {/* <div className="row mt-3">
                <div className=" col-lg-6 col-md-6 col-sm-12 ">
                  <div className="time_div">
                    <p className="days">Tue</p>
                  </div>
                </div>
                <div className=" col-lg-6 col-md-6 col-sm-12 ">
                  <div className="time_div">
                    <p className="days">10:00AM - 06:00PM</p>
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className=" col-lg-6 col-md-6 col-sm-12 ">
                  <div className="time_div">
                    <p className="days">Wed</p>
                  </div>
                </div>
                <div className=" col-lg-6 col-md-6 col-sm-12 ">
                  <div className="time_div">
                    <p className="days">10:00AM - 06:00PM</p>
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className=" col-lg-6 col-md-6 col-sm-12 ">
                  <div className="time_div">
                    <p className="days">Thu</p>
                  </div>
                </div>
                <div className=" col-lg-6 col-md-6 col-sm-12 ">
                  <div className="time_div">
                    <p className="days">10:00AM - 06:00PM</p>
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className=" col-lg-6 col-md-6 col-sm-12 ">
                  <div className="time_div">
                    <p className="days">Fri</p>
                  </div>
                </div>
                <div className=" col-lg-6 col-md-6 col-sm-12 ">
                  <div className="time_div">
                    <p className="days">10:00AM - 06:00PM</p>
                  </div>
                </div>
              </div> */}
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <p className="label1 labels">Business Description</p>
                <p>{previewData?.businessDescription}</p>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <p className="label1 labels">10 key words</p>
                <div className="input1 ps-2 pe-2 pb-2">
                  <div className="d-flex gap-1 flex-wrap">
                    {previewData.tags &&
                      previewData?.keywords.map((elem) => {
                        return (
                          <div className="badge_main">
                            <p>{elem.keywords}</p>
                            <div className="badge_inner">
                              <img src={cross} />
                            </div>
                          </div>
                        );
                      })}
                    {/* <div className="badge_main">
                    <p>Business</p>
                    <div className="badge_inner">
                      <img src={cross} />
                    </div>
                  </div>
                  <div className="badge_main">
                    <p>Mesa</p>
                    <div className="badge_inner">
                      <img src={cross} />
                    </div>
                  </div>
                  <div className="badge_main">
                    <p>Mesa</p>
                    <div className="badge_inner">
                      <img src={cross} />
                    </div>
                  </div>
                  <div className="badge_main">
                    <p>Mesa</p>
                    <div className="badge_inner">
                      <img src={cross} />
                    </div>
                  </div> */}
                    {/* <div className="badge_main">
                    <p>Mesa</p>
                    <div className="badge_inner">
                      <img src={cross} />
                    </div>
                  </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-8 col-md-6 col-sm-12">
                <p className="label1 labels">4- Business Images</p>
                <div className="d-flex gap-1 flex-wrap">
                {previewImg.length > 0?previewImg.map((url)=><img style={{ height: "160px", width: "180px" }} src={url} />):null}
          
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <p className="label1 labels">Business Video </p>
                <img src={video} />
              </div>
            </div>
            <div className="chackbox_div">
              <input
                type="checkbox"
                value={previewData?.sdfs}
                className="chackbox_input"
                style={{
                  backgroundColor: "rgba(217, 217, 217, 1)",
                  border: "none",
                }}
              />
              <p className="chackbox_p">
                I agree to the
                <span
                  style={{
                    textDecoration: "underline",
                    color: "rgba(45, 156, 219, 1)",
                  }}
                >
                  {" "}
                  Terms & Conditions
                </span>{" "}
                and
                <span
                  style={{
                    textDecoration: "underline",
                    color: "rgba(45, 156, 219, 1)",
                  }}
                >
                  {" "}
                  Privacy Policy
                </span>
                .
              </p>
            </div>
            <div className="chackbox_divs1">
              <button className="Proceed_btn" onClick={proceed}>
                PROCEED
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Preview;
